__turbopack_context__.v({
  "__link": "navbar-question-list-module-scss-module__33GmLa____link",
  "navbar-question-list": "navbar-question-list-module-scss-module__33GmLa__navbar-question-list",
});
